import { COMPANY, PHONE, SITE } from "@/lib/siteConfig";
import { LegalPage, LegalSection, LegalSubheading } from "@/components/landing/LegalPage";

export default function Datenschutz() {
  return (
    <LegalPage
      eyebrow="Rechtliches"
      title="Datenschutzerklärung"
      intro="Informationen zur Verarbeitung personenbezogener Daten gemäß Datenschutz-Grundverordnung (DSGVO) und Bundesdatenschutzgesetz (BDSG)."
      metaDescription={`Datenschutzerklärung von ${COMPANY.name} – Informationen zur Datenverarbeitung gemäß DSGVO auf securitystaging.de.`}
      testId="datenschutz-page"
    >
      <LegalSection title="1. Verantwortlicher">
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist:
        </p>
        <p className="not-italic bg-slate-50 border border-slate-200 rounded-xl p-4 mt-3">
          <strong className="text-slate-900">{COMPANY.name}</strong>
          <br />
          Inhaber: {COMPANY.owner}
          <br />
          {COMPANY.street}
          <br />
          {COMPANY.postalCode} {COMPANY.city}
          <br />
          {COMPANY.countryName}
          <br />
          Telefon:{" "}
          <a href={`tel:${PHONE.tel}`} className="text-[#0A2340] font-semibold hover:text-[#EAB308]">
            {PHONE.display}
          </a>
          <br />
          E-Mail:{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#0A2340] font-semibold hover:text-[#EAB308]"
          >
            {COMPANY.email}
          </a>
        </p>
      </LegalSection>

      <LegalSection title="2. Allgemeine Hinweise zur Datenverarbeitung">
        <p>
          Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst und behandeln Ihre Daten vertraulich, entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. Bei der Nutzung unserer Webseite werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
        </p>
        <p>
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>
      </LegalSection>

      <LegalSection title="3. Erhebung von Daten beim Besuch unserer Webseite">
        <LegalSubheading>Server-Log-Dateien</LegalSubheading>
        <p>
          Beim Aufruf unserer Webseite werden durch unseren Hosting-Provider automatisch Informationen erhoben und in sogenannten Server-Log-Dateien gespeichert, die Ihr Browser übermittelt. Dies sind:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners (anonymisierte IP-Adresse)</li>
          <li>Uhrzeit der Serveranfrage</li>
        </ul>
        <p>
          Die Speicherung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur Gewährleistung eines störungsfreien Betriebs, der Sicherheit und zur statistischen Auswertung. Eine Zusammenführung dieser Daten mit anderen Datenquellen findet nicht statt.
        </p>
      </LegalSection>

      <LegalSection title="4. Kontaktaufnahme">
        <LegalSubheading>Kontakt per Telefon</LegalSubheading>
        <p>
          Wenn Sie uns telefonisch kontaktieren, werden Ihre Angaben zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Bearbeitung).
        </p>

        <LegalSubheading>Kontakt per E-Mail</LegalSubheading>
        <p>
          Wenn Sie uns per E-Mail an{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            {COMPANY.email}
          </a>{" "}
          Anfragen zukommen lassen, werden Ihre Angaben inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
        </p>
        <p>
          Die von Ihnen übermittelten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
        </p>
      </LegalSection>

      <LegalSection title="5. Cookies">
        <p>
          Unsere Webseite verwendet Cookies bzw. lokale Speichereinträge in zwei Kategorien:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Technisch notwendige Cookies:</strong> Erforderlich für den Betrieb der Seite (z. B. Speicherung der Cookie-Auswahl). Rechtsgrundlage: § 25 Abs. 2 Nr. 2 TTDSG.
          </li>
          <li>
            <strong>Analyse-Cookies (opt-in):</strong> Werden nur nach Ihrer ausdrücklichen Einwilligung gesetzt (siehe unser Cookie-Banner beim ersten Aufruf). Rechtsgrundlage: § 25 Abs. 1 TTDSG i. V. m. Art. 6 Abs. 1 lit. a DSGVO.
          </li>
        </ul>
        <p>
          Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder anpassen:
        </p>
        <p>
          <button
            type="button"
            onClick={() => window.__ssOpenCookieSettings && window.__ssOpenCookieSettings()}
            className="inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold bg-[var(--ss-gold)] text-[#071A2B] hover:brightness-105 transition"
            data-testid="datenschutz-open-cookie-settings"
          >
            Cookie-Einstellungen öffnen
          </button>
        </p>
        <p className="text-xs text-slate-500">
          Sie können Ihren Browser zusätzlich so einstellen, dass Sie über das Setzen von Cookies informiert werden und einzeln über deren Annahme entscheiden. Bei der Nichtannahme von Cookies kann die Funktionalität unserer Webseite eingeschränkt sein.
        </p>
      </LegalSection>

      <LegalSection title="6. Analyse-Tools und externe Dienste">
        <LegalSubheading>Google Fonts</LegalSubheading>
        <p>
          Zur einheitlichen Darstellung von Schriftarten nutzt diese Seite Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts, um Texte und Schriftarten korrekt anzuzeigen. Zu diesem Zweck stellt Ihr Browser eine Verbindung zu den Servern von Google her. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen:{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            policies.google.com/privacy
          </a>
          .
        </p>

        <LegalSubheading>Unsplash (Bildhosting)</LegalSubheading>
        <p>
          Bilder auf dieser Seite werden teilweise von Unsplash Inc. (US) bereitgestellt. Beim Laden dieser Bilder stellt Ihr Browser eine Verbindung zu den Servern von Unsplash her. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an schneller Bereitstellung optimierter Bilder).
        </p>

        <LegalSubheading>Reichweitenanalyse (PostHog)</LegalSubheading>
        <p>
          Diese Webseite nutzt zur pseudonymisierten Reichweitenanalyse den Dienst <strong>PostHog</strong> (PostHog Inc., 2261 Market Street #4008, San Francisco, CA 94114, USA). Dabei können pseudonymisierte Nutzungsdaten erhoben werden (z. B. Seitenaufrufe, Geräte-Typ, Referrer, gekürzte IP). Eine personenbezogene Identifizierung findet nicht statt.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) i. V. m. § 25 Abs. 1 TTDSG. PostHog wird <strong>ausschließlich nach Ihrer aktiven Zustimmung</strong> über den Cookie-Banner geladen. Sie können Ihre Einwilligung jederzeit über die{" "}
          <button
            type="button"
            onClick={() => window.__ssOpenCookieSettings && window.__ssOpenCookieSettings()}
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            Cookie-Einstellungen
          </button>{" "}
          widerrufen.
        </p>
        <p>
          Datenübertragung in Drittstaaten (USA): Die Übertragung erfolgt auf Basis der EU-Standardvertragsklauseln (Art. 46 DSGVO). Weitere Informationen:{" "}
          <a
            href="https://posthog.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            posthog.com/privacy
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="7. Hosting">
        <p>
          Unsere Webseite wird bei einem externen Dienstleister gehostet. Personenbezogene Daten, die auf dieser Webseite erfasst werden, werden auf den Servern des Hosters gespeichert. Der Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten erforderlich ist und unseren Weisungen in Bezug auf diese Daten folgen. Wir haben mit dem Hoster einen Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO abgeschlossen.
        </p>
      </LegalSection>

      <LegalSection title="8. Ihre Rechte als betroffene Person">
        <p>Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            {COMPANY.email}
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="9. Beschwerderecht bei einer Aufsichtsbehörde">
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständige Behörde für den Betreiber ist:
        </p>
        <p className="not-italic bg-slate-50 border border-slate-200 rounded-xl p-4 mt-2">
          Landesbeauftragte für Datenschutz und Informationsfreiheit
          <br />
          Nordrhein-Westfalen (LDI NRW)
          <br />
          Kavalleriestraße 2–4, 40213 Düsseldorf
          <br />
          Website:{" "}
          <a
            href="https://www.ldi.nrw.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            ldi.nrw.de
          </a>
        </p>
      </LegalSection>

      <LegalSection title="10. Datensicherheit">
        <p>
          Wir verwenden innerhalb des Webseiten-Besuchs das verbreitete SSL/TLS-Verfahren in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schlüssel- bzw. Schloss-Symbols in der Browser-Zeile.
        </p>
      </LegalSection>

      <LegalSection title="11. Aktualität und Änderung dieser Datenschutzerklärung">
        <p>
          Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Webseite oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Fassung kann jederzeit auf{" "}
          <a
            href={SITE.url + "/datenschutz"}
            className="text-[#0A2340] font-semibold underline underline-offset-4 hover:text-[#EAB308]"
          >
            {SITE.url.replace(/^https?:\/\//, "")}/datenschutz
          </a>{" "}
          abgerufen werden.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
